/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as CategoryRouteImport } from './routes/$category'
import { Route as SearchRouteImport } from './routes/search'
import { Route as CategoryIndexRouteImport } from './routes/$category/index'
import { Route as CategoryIdRouteImport } from './routes/$category/$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoryRoute = CategoryRouteImport.update({
  id: '/$category',
  path: '/$category',
  getParentRoute: () => rootRouteImport,
} as any)
const SearchRoute = SearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRouteImport,
} as any)
const CategoryIndexRoute = CategoryIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => CategoryRoute,
} as any)
const CategoryIdRoute = CategoryIdRouteImport.update({
  id: '/$id',
  path: '/$id',
  getParentRoute: () => CategoryRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$category': typeof CategoryRouteWithChildren
  '/search': typeof SearchRoute
  '/$category/$id': typeof CategoryIdRoute
  '/$category/': typeof CategoryIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/search': typeof SearchRoute
  '/$category/$id': typeof CategoryIdRoute
  '/$category': typeof CategoryIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$category': typeof CategoryRouteWithChildren
  '/search': typeof SearchRoute
  '/$category/$id': typeof CategoryIdRoute
  '/$category/': typeof CategoryIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/$category' | '/search' | '/$category/$id' | '/$category/'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/search' | '/$category/$id' | '/$category'
  id:
    | '__root__'
    | '/'
    | '/$category'
    | '/search'
    | '/$category/$id'
    | '/$category/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  CategoryRoute: typeof CategoryRouteWithChildren
  SearchRoute: typeof SearchRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$category': {
      id: '/$category'
      path: '/$category'
      fullPath: '/$category'
      preLoaderRoute: typeof CategoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/search': {
      id: '/search'
      path: '/search'
      fullPath: '/search'
      preLoaderRoute: typeof SearchRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$category/': {
      id: '/$category/'
      path: '/'
      fullPath: '/$category/'
      preLoaderRoute: typeof CategoryIndexRouteImport
      parentRoute: typeof CategoryRoute
    }
    '/$category/$id': {
      id: '/$category/$id'
      path: '/$id'
      fullPath: '/$category/$id'
      preLoaderRoute: typeof CategoryIdRouteImport
      parentRoute: typeof CategoryRoute
    }
  }
}

interface CategoryRouteChildren {
  CategoryIdRoute: typeof CategoryIdRoute
  CategoryIndexRoute: typeof CategoryIndexRoute
}

const CategoryRouteChildren: CategoryRouteChildren = {
  CategoryIdRoute: CategoryIdRoute,
  CategoryIndexRoute: CategoryIndexRoute,
}

const CategoryRouteWithChildren = CategoryRoute._addFileChildren(
  CategoryRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  CategoryRoute: CategoryRouteWithChildren,
  SearchRoute: SearchRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
